import React, { useState, useEffect, Fragment } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import 'react-datepicker/dist/react-datepicker.css';
import CloseIcon from '@mui/icons-material/Close';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { DatePickerFormikField } from '../../../components/Common/FormikField/DatePickerFormikField/DatePickerFormikField';
import moment from 'moment';
import { GetSchema, string_required, date_picker } from '../../../js/Base/ValidationSchema';
import { editProject, createProject } from '../../../api/projectApi';
import { FormControlLabel, Typography } from '@mui/material';
import { GreenSwitch } from '../../../components/Common/GreenSwitch';

const EditProjectModal = ({ project, companyMembers, isModalOpen, handleClose, isCreate, submitEffect }) => {
  const [initialValues, setInitialValues] = useState({
    name: project?.name ?? '',
    // company_type: project?.company_type ?? null,
    begin_dt: project?.begin_dt
    ? moment.utc(project.begin_dt).local().format('YYYY-MM-DD HH:mm')
    : '',
    memo: project?.memo ?? '',
    oid: project?.oid ?? '',
    // cef_path: project?.cef_path ?? '',
    company_member_uuid: project?.company_member_uuid ?? '',
    scan_enabled: project?.scan_enabled ?? true,
  });

  const formSchema = GetSchema({
    name: string_required(),
    begin_dt: date_picker(),
    memo: string_required(),
    oid: string_required(),
    // cef_path: string_required(),
    company_member_uuid: string_required(),
  });


  const createProjectByWebApi = async (values) => {
    const payload = {
      company_id: localStorage.getItem("company_id"),
      company_uuid: localStorage.getItem("company_uuid"),
      create_acct: localStorage.getItem("user_email"),
      name: values.name,
      // company_type: values.company_type ? Number(values.company_type) : null,
      begin_dt:  moment(values.begin_dt),
      company_member_uuid: values.company_member_uuid,
      oid: values.oid,
      // cef_path: values.cef_path,
      memo: values.memo,
      scan_enabled: values.scan_enabled,
      status:1,
    };

    const res = await createProject(payload);
    if (!res.data.success) {
      toastAlert.autoClose(true).showError("新增失敗");
    } else {
      toastAlert.autoClose(true).showSuccess("新增成功");
    }
  };

  const editProjectByWebApi = async (values) => {
    const payload = {
      ...values,
      acct_email: localStorage.getItem("user_email"),
    };

    const res = await editProject(payload);
    if (!res.data.success) {
      toastAlert.autoClose(true).showError("編輯失敗");
    } else {
      toastAlert.autoClose(true).showSuccess("編輯成功");
    }
  };


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
  
      if (isCreate) {
        await createProjectByWebApi(values);
      } else {
        let payload = {
          project_id: project.id,
          project_uuid: project.uuid
        };
        if (values.name !== project.name) payload.name = values.name;
        // if (values.company_type !== null && values.company_type !== '' && values.company_type !== project.company_type) {
        //   payload.company_type = Number(values.company_type)}
        if (values.begin_dt) payload.begin_dt = moment(values.begin_dt);
        if (values.company_member_uuid) payload.company_member_uuid = values.company_member_uuid;
        if (values.oid !== project.oid) payload.oid = values.oid;
        // if (values.cef_path !== project.cef_path) payload.cef_path = values.cef_path;
        if (values.memo !== project.memo) payload.memo = values.memo;
        if (values.scan_enabled !== project.scan_enabled) payload.scan_enabled = values.scan_enabled;

        await editProjectByWebApi(payload);
      }
      handleClose();
      submitEffect();
  
    } catch (error) {
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      handleClose(resetForm);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '8999' }}
        show={isModalOpen}
        onHide={() => {
          handleClose();
        }}
        dialogClassName="ProcessManagement Modal"
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>{isCreate ? '新增專案' : '編輯專案'}</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={formSchema}
          enableReinitialize={true}
        >
          {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
            <Form className="form" style={{ padding:'0px' }}>
              <Modal.Body className="modal-body" style={{ paddingTop:'0px' }}>
              <InputFormFiled
              title="專案名稱"
              name="name"
              type="text"
              invalid={errors.name && touched.name}
              />

              {/* <InputFormFiled
              title="企業類別"
              name="company_type"
              type="text"
              invalid={errors.company_type && touched.company_type}
              /> */}

              <p
              style={{
                  fontSize: '12px',
                  color: '#323232',
                  fontWeight: 'bold',
                  marginTop: '20px',
                  marginBottom: '6px',
              }}
              >
              開始時間
              </p>

              <DatePickerFormikField
                name="begin_dt"
                selected={new Date()}
                timeInputLabel="Time:"
                dateFormat="yyyy-MM-dd HH:mm"
                showTimeInput
                isInvalid={errors.begin_dt && touched.begin_dt}
              />
              <ErrorMessage name="begin_dt">{(msg) => <span className="text-danger">{msg}</span>}</ErrorMessage>

              <InputFormFiled
                title="專案負責人"
                name="company_member_uuid"
                type="select"
                options={
                    companyMembers.length > 0
                    ? companyMembers.map((member) => {
                        return {
                          uuid: member.uuid,
                          name: `姓名: ${member.name} | 帳號: ${member.email}`,
                        };
                        })
                    : []
                }
                invalid={errors.company_member_uuid && touched.company_member_uuid}
              />

              <InputFormFiled
              title="OID"
              name="oid"
              type="text"
              invalid={errors.oid && touched.oid}
              />

              {/* <InputFormFiled
              title="CEF檔案路徑"
              name="cef_path"
              type="text"
              invalid={errors.cef_path && touched.cef_path}
              /> */}

              <InputFormFiled
              title="備註"
              name="memo"
              type="text"
              invalid={errors.memo && touched.memo}
              />

              {/* InputFormFiled 只支援 select / textarea / 一般 input，checkbox 塞進 InputGroup 樣式會歪，故自行渲染 */}
              <p
                style={{
                  fontSize: '12px',
                  color: '#323232',
                  fontWeight: 'bold',
                  marginTop: '20px',
                  marginBottom: '0px',
                }}
              >
                是否掃描
              </p>
              <FormControlLabel
                checked={!!values.scan_enabled}
                onChange={() => setFieldValue('scan_enabled', !values.scan_enabled)}
                control={<GreenSwitch />}
                label={
                  <Typography sx={{ fontSize: '13px' }}>
                    {values.scan_enabled ? '啟用掃描' : '停用掃描'}
                  </Typography>
                }
                labelPlacement="end"
                sx={{ marginLeft: 0 }}
              />
              <p style={{ fontSize: '12px', color: '#767676', marginBottom: '0px' }}>
                啟用後會以台北時間每月 1 日 08:00 建立預設訂閱，可到「掃描排程訂閱」調整。
              </p>
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <Button
              type="button"
              className="btn btn-cancel"
              onClick={() => {
                resetForm();
                handleClose();
              }}
            >
              取消
            </Button>
            <Button type="submit" className="btn btn-custom" disabled={isSubmitting}>
              確認
            </Button>
          </Modal.Footer>
        </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default EditProjectModal;
